/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createInvestmentAccountTransactionGetResponseFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeInvestmentAccountTransactionPostRequest, type InvestmentAccountTransactionGetResponse, type InvestmentAccountTransactionPostRequest, type ProblemDetails } from '../../../../../models';
// @ts-ignore
import { type WithTransactionItemRequestBuilder, WithTransactionItemRequestBuilderRequestsMetadata } from './item';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /investmentaccounts/{investmentAccountId}/tickers/{tickerId}/transactions
 */
export interface TransactionsRequestBuilder extends BaseRequestBuilder<TransactionsRequestBuilder> {
    /**
     * Gets an item from the MoneyChecker.Web.ApiClient.investmentaccounts.item.tickers.item.transactions.item collection
     * @param transactionId Unique identifier of the item
     * @returns {WithTransactionItemRequestBuilder}
     */
     byTransactionId(transactionId: Guid) : WithTransactionItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvestmentAccountTransactionGetResponse[]>}
     * @throws {ProblemDetails} error when the service returns a 404 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvestmentAccountTransactionGetResponse[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     */
     post(body: InvestmentAccountTransactionPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: InvestmentAccountTransactionPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const TransactionsRequestBuilderUriTemplate = "{+baseurl}/investmentaccounts/{investmentAccountId}/tickers/{tickerId}/transactions";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const TransactionsRequestBuilderNavigationMetadata: Record<Exclude<keyof TransactionsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byTransactionId: {
        requestsMetadata: WithTransactionItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["transactionId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const TransactionsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: TransactionsRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createInvestmentAccountTransactionGetResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: TransactionsRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeInvestmentAccountTransactionPostRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
